var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"id":"loading"}},[_c('b-spinner',{attrs:{"label":"Loading...","variant":"primary","type":"grow"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }